import classNames from './StoreButtons.module.scss';
import SVG from 'react-inlinesvg';
import appStoreImg from '@/assets/svg/app-store.svg';
import googlePlayImg from '@/assets/svg/google-play.svg';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import { useMemo } from 'react';

const StoreButtons = () => {
  const { nativeLanguage } = useAppSelector(authSelector);

  const isNativeLanguageHE = useMemo(() => {
    return nativeLanguage === 'he';
  }, [nativeLanguage]);

  if (isNativeLanguageHE) {
    return <></>;
  }

  return (
    <div className={classNames.storeButtons}>
      <button
        onClick={() =>
          window.open(
            'https://apps.apple.com/us/app/hello-britannica/id6472614240',
            '_blank',
            'noopener,noreferrer'
          )
        }
      >
        <SVG src={appStoreImg} />
      </button>
      <button
        onClick={() =>
          window.open(
            'https://play.google.com/store/apps/details?id=com.melingo.app',
            '_blank',
            'noopener,noreferrer'
          )
        }
      >
        <SVG src={googlePlayImg} />
      </button>
    </div>
  );
};

export default StoreButtons;
